import {
  AuthGuard,
  FooterComponent,
  HideSearch,
  HomeComponent,
  ObjectName,
  RouterDataGenerator,
  RouteSecurityGenerator,
} from "@edtell-common";
import { RouterModule, Routes } from "@angular/router";
import { CatalogSearch } from "../../modules/catalog/services/catalog.search";
import { CustomerSearch } from "../../modules/customer/services/customer.search";
import { ProviderSearch } from "../../modules/providers/services/provider.search";
import { AppContainerComponent } from "./components/app-container.component";
import { EnrollmentHeaderComponent } from "../../modules/enrollment/components/enrollment-header/enrollment-header.component";
import { RegistrationSearch } from "../../modules/registrations/searches/registration.search";
import { HeaderComponent } from "../header/header.component";
import { ProcessedJobStatusUpdateInterceptor } from "../../modules/edtell-common/processed/interceptors/processed-job-status-update.interceptor";
import { EnrollmentFooterComponent } from "../../modules/edtell-common/enrollment-footer/enrollment-footer.component";

const appRoutes: Routes = [
  {
    path: "",
    component: AppContainerComponent,
    canActivateChild: [AuthGuard],
    children: [
      {
        path: "",
        component: HomeComponent,
      },
      {
        path: "admin",
        loadChildren: () =>
          import("../../modules/admin/admin.module").then((m) => m.AdminModule),
        canActivateChild: [AuthGuard],
        data: {
          routerData: RouterDataGenerator.generateSimpleRouterData("Admin"),
          security: [
            RouteSecurityGenerator.generateAccessLevelSecurity(
              ObjectName.SYSTEM_PROPERTIES,
            ),
            RouteSecurityGenerator.generateRoleSecurity({ systemAdmin: true }),
          ],
        },
      },
      {
        path: "jobs",
        loadChildren: () =>
          import("../../modules/srs-processed/srs-processed.module").then(
            (m) => m.SrsProcessedRoutingModule,
          ),
      },
      {
        path: "customer",
        loadChildren: () =>
          import("../../modules/customer/customer.module").then(
            (m) => m.CustomerRoutingModule,
          ),
        data: {
          security: RouteSecurityGenerator.generateAccessLevelSecurity(
            ObjectName.CUSTOMER_PROFILE,
          ),
          routerData: RouterDataGenerator.generateSimpleRouterData("Customer"),
          search: CustomerSearch,
        },
      },
      {
        path: "external-utilities",
        loadChildren: () =>
          import(
            "../../modules/external-utilities/external-utilities.module"
          ).then((m) => m.ExternalUtilitiesModule),
        data: {
          security: RouteSecurityGenerator.generateAccessLevelSecurity(
            ObjectName.EXTERNAL_UTILITIES,
          ),
          routerData:
            RouterDataGenerator.generateSimpleRouterData("External Utilities"),
        },
      },
      {
        path: "providers",
        loadChildren: () =>
          import("../../modules/providers/providers.module").then(
            (m) => m.ProvidersModule,
          ),
        data: {
          security: RouteSecurityGenerator.generateAccessLevelSecurity(
            ObjectName.PROVIDER_PROFILE,
          ),
          routerData: RouterDataGenerator.generateSimpleRouterData("Providers"),
          search: ProviderSearch,
        },
      },
      {
        path: "catalog",
        loadChildren: () =>
          import("../../modules/catalog/catalog.module").then(
            (m) => m.CatalogModule,
          ),
        data: {
          security: RouteSecurityGenerator.generateAccessLevelSecurity(
            ObjectName.CATALOG_COURSE_PROFILE,
          ),
          search: CatalogSearch,
        },
      },
      {
        path: "enrollment",
        loadChildren: () =>
          import("../../modules/enrollment/enrollment.module").then(
            (m) => m.EnrollmentRoutingModule,
          ),
        data: {
          search: null,
          skipAuth: true,
          header: EnrollmentHeaderComponent,
          footer: EnrollmentFooterComponent,
        },
      },
      {
        path: "preview/enrollment",
        loadChildren: () =>
          import("../../modules/enrollment/enrollment.module").then(
            (m) => m.EnrollmentRoutingModule,
          ),
        data: {
          search: null,
          skipAuth: true,
          header: EnrollmentHeaderComponent,
          footer: EnrollmentFooterComponent,
        },
      },
      {
        path: "registrations",
        loadChildren: () =>
          import("../../modules/registrations/registrations.module").then(
            (m) => m.RegistrationsRoutingModule,
          ),
        data: {
          security: RouteSecurityGenerator.generateAccessLevelSecurity(
            ObjectName.REGISTRATIONS,
          ),
          search: RegistrationSearch,
        },
      },
      {
        path: "operations",
        loadChildren: () =>
          import("../../modules/operations/operations.module").then(
            (m) => m.OperationsRoutingModule,
          ),
        data: {
          security: RouteSecurityGenerator.generateAccessLevelSecurity(
            ObjectName.OPERATIONS,
          ),
        },
      },
      {
        path: "communications",
        loadChildren: () =>
          import("../../modules/communications/communications.module").then(
            (m) => m.CommunicationsRoutingModule,
          ),
        data: {
          security: RouteSecurityGenerator.generateAccessLevelSecurity(
            ObjectName.COMMUNICATIONS,
          ),
          search: null,
        },
      },
      {
        path: "reports",
        loadChildren: () =>
          import("../../modules/reports/reports.module").then(
            (m) => m.ReportsRoutingModule,
          ),
        data: {
          security: RouteSecurityGenerator.generateAccessLevelSecurity(
            ObjectName.REPORTS,
          ),
          routerData: RouterDataGenerator.generateSimpleRouterData("Reports"),
        },
      },
      {
        path: "knowledge-base",
        loadChildren: () =>
          import("../../modules/knowledge-base/knowledge-base.module").then(
            (m) => m.KnowledgeBaseModule,
          ),
        data: {
          security: RouteSecurityGenerator.generateAccessLevelSecurity(
            ObjectName.KNOWLEDGE_BASE,
          ),
          routerData:
            RouterDataGenerator.generateSimpleRouterData("Knowledge Base"),
        },
      },
    ],
    data: {
      search: HideSearch,
      sidebar: null,
      header: HeaderComponent,
      footer: FooterComponent,
      interceptors: [ProcessedJobStatusUpdateInterceptor],
    },
  },
];

export const APP_CONTAINER_ROUTING = RouterModule.forChild(appRoutes);
